import React, { forwardRef, useEffect, useRef, useState } from "react";
import {
    MDBBtn,
    MDBIcon,
    MDBTypography,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBDatatable,
    MDBInput,
    MDBSpinner,
    MDBContainer,
    MDBAlert,
    MDBProgress,
    MDBProgressBar,
} from 'mdb-react-ui-kit';

import { useTranslation } from "react-i18next";
import PopupLoader from "../../../views/popups/PopupLoader";
import { checkUploadStatus, exportUsersInfo, fetchImpExpMiscDetails, impExpCancel, impExpReValidate, impExpSave, impExpSkip, uploadUsersInfo } from "../../../apiclients/streamsapi_bridge";
import { useFieldArray, useForm } from "react-hook-form";
import UploadFile from "./UploadFile";
import ErrorValidataion from "./ErrorValidataion";
import SuccessValidationPage from "./SuccessValidationPage";
const ImportUser = (props) => {
    const [selectedFiles, setselectedFiles] = useState(null);
    const [userDetails, setuserDetails] = useState({});
    const [tempUserInfo, settempUserInfo] = useState({});
    const [statusRequest, setstatusRequest] = useState(false);
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [isValidated, setIsValidated] = useState(false);
    const [isImported, setIsImported] = useState(false);
    const [isInValid, setIsInvalid] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [statusPercentage, setstatusPercentage] = useState("0");
    const [centredModal, setCentredModal] = useState(false);
    const [isloading, setIsloading] = useState(false);
    const toggleOpen = () => setCentredModal(!centredModal);
    const [internalError, setinternalError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [createList, setcreateList] = useState([]);
    const [updateList, setupdateList] = useState([]);
    const [deleteList, setdeleteList] = useState([]);
    const [skipUserList, setskipUserList] = useState([]);
    const [skippedRecords, setSkippedRecords] = useState({});
    const [sheetstatus, setsheetstatus] = useState(-1);
    const [finalSaveStatus, setfinalSaveStatus] = useState(false);
    const [disableImportButton, setdisableImportButton] = useState(false);
    const [disableExport, setdisableExport] = useState(false);
    const [savingRecordInfo, setsavingRecordInfo] = useState({});
    const [totalSheetRecords, settotalSheetRecords] = useState(0);
    const [recordNoAction, setrecordNoAction] = useState(0);
    const [recordsProcess, setrecordsProcess] = useState(0);
    const [defaultCalleridFlag, setdefaultCalleridFlag] = useState(0);
    const [showUsers, setShowUsers] = useState(false);
    const [forceStop, setforceStop] = useState(false);
    const [responseStatus, setresponseStatus] = useState(-1);

    // NEW: state to control the "continue existing import?" popup
    const [showContinuePopup, setShowContinuePopup] = useState(false);

    // NEW: flag to track that handleCancelContinue was triggered (user discarded in-progress import)
    const [cancelContinueTriggered, setCancelContinueTriggered] = useState(false);

    useEffect(() => {
        if (internalError) {
            setTimeout(() => {
                setinternalError(false)
                setErrorMessage("");
            }, 5000);
        }
    }, [internalError]);

    const { register, handleSubmit, watch, setValue, formState: { isDirty, dirtyFields }, reset, control } = useForm({
        defaultValues: {
            validate_users_data: [],
        }
    });

    useEffect(() => {
        if (props.firstRequest) {
            setforceStop(false);
            uploadSheetStatus();
        }

    }, [props.firstRequest])

    // NEW: user clicks "Proceed" — continue the existing import
    const handleContinueImport = async () => {
        setShowContinuePopup(false);
        await uploadSheetStatus();
    };

    // NEW: user clicks "Cancel" — navigate back to the upload sheet first page
    const handleCancelContinue = async () => {
    setShowContinuePopup(false);
    setIsloading(true);

    let saverep = await impExpCancel(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
    let saverepeMsg = await saverep.json();

    setIsloading(false);

    if (saverepeMsg.status && saverepeMsg.status == "success") {
        if (props.firstRequest) {
            props.setfirstRequest(false);
        }
        setIsValidated(false);
        setIsImported(false);
        setIsInvalid(false);
        setselectedFiles(null);
        setuserDetails({});
        setErrorMessage("");
        setcreateList([]);
        setupdateList([]);
        setdeleteList([]);
        setskipUserList([]);
            setSkippedRecords({});
        setCancelContinueTriggered(true);
    } else {
        setinternalError(true);
        setErrorMessage(saverepeMsg.message);
    }
};

    const toggleisImported = () => {
        setIsImported(!isImported);
        // setTimeout(() => {
        //     setIsLoading(false);
        //     setIsValidated(!isValidated);
        // }, 3000);
    };


    const handleExportUsers = (e) => {
        e.preventDefault();
        setdisableExport(true);
        setIsloading(true);
        exportUsersData();
    };

    const exportUsersData = async () => {
        try {
            let apiResponse = await exportUsersInfo(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
            if (apiResponse.status == 200) {
                const contentDisposition = apiResponse.headers.get("Content-Disposition");
                setdisableExport(false);
                setTimeout(() => {
                    setIsloading(false);
                }, 1000);
                let filename = "";
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="?([^"]+)"?/);
                    if (match && match[1]) {
                        filename = match[1];
                    }
                }
                const fileUrl = URL.createObjectURL(await apiResponse.blob());
                const a = document.createElement("a");
                a.href = fileUrl;
                a.download = filename;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            } else {
                setdisableExport(false);
                setIsloading(false);
            }
        } catch (error) {
            console.log("Export error: " + error);
            setdisableExport(false);
            setIsloading(false);
        }
    };

    const handleUploadToValidate = async () => {
        setdisableImportButton(true);
        const formData = new FormData();
        formData.append(
            "siteid",
            JSON.parse(sessionStorage.getItem("admin_session")).siteid
        );
        //   formData.append("reqid",  91);
        formData.append("sheet", selectedFiles);
        setIsloading(true);

        let saverep = await uploadUsersInfo(formData);
        let saverepeMsg = await saverep.json();

        setIsloading(false);

        console.log("response of next:::" + JSON.stringify(saverepeMsg));

        if (saverepeMsg.status && saverepeMsg.status == "success") {
            // setstatusRequest(true);
            setIsLoading(true);
            await uploadSheetStatus();
        } else {
            setinternalError(true);
            setErrorMessage(saverepeMsg.message);
            setdisableImportButton(false);

        }

    }

    // useEffect(() => {

    //         fetchMiscData();



    // }, []);

    async function uploadSheetStatus() {
        try {
            const response = await checkUploadStatus(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
            const statusData = await response.json();
            console.log(" ::::::::::::::: Polling Status ::::::::::::::::::", JSON.stringify(statusData));
            setsheetstatus(statusData?.status ?? -1);
            if ((statusData.status === 1 || statusData.status === 4 || statusData.status === 6 || statusData.status === 7) && !forceStop) {
                if (props.firstRequest) {
                    props.setfirstRequest(false);
                    setfinalSaveStatus(true);
                    setIsLoading(true);
                }
                const statusPercentage = statusData.percentage ?? "0";
                if (
                    typeof statusPercentage === "string" &&
                    statusPercentage.includes("/")
                ) {
                    const [current, total] = statusPercentage
                        .split("/")
                        .map((s) => parseInt(s.trim(), 10));
                    const progress = (current / total) * 100;

                    setstatusPercentage(Math.round(progress))
                } else {
                    setstatusPercentage(statusData.percentage);
                }
                // setstatusPercentage(statusData.percentage);
                setresponseStatus(statusData.status);
                await uploadSheetStatus();
            } else if (statusData.status === 2) {
                if(props.firstRequest) {
                props.setfirstRequest(false);
                setShowContinuePopup(true);
                }
                setdisableImportButton(false);

                setTimeout(() => {
                    setIsLoading(false);
                }, 500);
                setIsImported(true);
                setIsInvalid(true);
                const errorDetails = statusData?.errors ?? {};
                const errorList = errorDetails?.error_rows ?? [];
                if (errorList.length > 0) {
                    setuserDetails(errorDetails);
                }
                const skippedData = statusData?.skipped ?? {};
                setSkippedRecords(skippedData);
                setstatusPercentage("0");

            } else if (statusData.status === 3) {
                 if(props.firstRequest) {
                props.setfirstRequest(false);
                setShowContinuePopup(true);
                 }
                setdisableImportButton(false);
                setstatusPercentage(statusData.percentage);
                // setTimeout(() => {
                    setIsLoading(false);
                // }, 500);
                setIsValidated(false);
                setIsImported(true);
                setIsInvalid(false);
                setcreateList(statusData?.data?.create ?? []);
                setupdateList(statusData?.data?.update ?? []);
                setdeleteList(statusData?.data?.delete ?? []);
                settotalSheetRecords(statusData?.data?.total_records !== undefined ? statusData?.data?.total_records : 0)
                setrecordNoAction(statusData?.data?.no_action !== undefined ? statusData?.data?.no_action : 0)
                setrecordsProcess(statusData?.data?.rows_process !== undefined ? statusData?.data?.rows_process : 0)
                setdefaultCalleridFlag(statusData?.data?.is_default_caller_id !== undefined ? statusData.data.is_default_caller_id : 0)
                setstatusPercentage("0");

            } else if (statusData.status === 5) {
                setdisableImportButton(false);
                setstatusPercentage(statusData.percentage);
                setTimeout(() => {
                    setIsLoading(false);
                }, 500);
                setfinalSaveStatus(false);
                setIsInvalid(false);
                setIsImported(true);
                setIsValidated(true);
                setsavingRecordInfo(statusData?.data ?? {})

            } else if (statusData.status === 0) {
                setfinalSaveStatus(false);
                setIsLoading(false);

            }
            if (props.firstRequest) {
                props.setfirstRequest(false);
            }


        } catch (error) {
            console.error("Error while polling:", error);
            setstatusPercentage("0");
        }

    }


    const handleInvalidData = async (data) => {
        let update = {
            siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            ...data,
        }
        setIsloading(true);

        let saverep = await impExpReValidate(update);
        let saverepeMsg = await saverep.json();

        setIsloading(false);
        console.log("handleInvalidData of next:::" + JSON.stringify(saverepeMsg));

        if (saverepeMsg.status && saverepeMsg.status == "success") {
            setIsLoading(true);
            await uploadSheetStatus();
        } else {
            setinternalError(true);
            setErrorMessage(saverepeMsg.message);

        }

    }
    const handleSaveData = async () => {

        setIsloading(true);
        let saverep = await impExpSave(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        let saverepeMsg = await saverep.json();

        setIsloading(false);
        console.log("handleSaveData of next:::" + JSON.stringify(saverepeMsg));

        if (saverepeMsg.status && saverepeMsg.status === "success") {
            setfinalSaveStatus(true);
            setIsLoading(true);
            await uploadSheetStatus();
        } else {
            setinternalError(true);
            setErrorMessage(saverepeMsg.message);

        }

    }
    const handleFinishRequest = async () => {

        window.location.href = "/userlanding";
    }

    const handleSkipData = async (data) => {

        setIsloading(true);

        let saverep = await impExpSkip(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        setIsloading(false);
        let saverepeMsg = await saverep.json();


        console.log("handleSkipData of next:::" + JSON.stringify(saverepeMsg));

        if (saverepeMsg?.status_info?.status && saverepeMsg?.status_info?.status === 3) {

            setIsValidated(false);
            setIsImported(true);
            setIsInvalid(false);
            setcreateList(saverepeMsg?.status_info?.data?.create ?? []);
            setupdateList(saverepeMsg?.status_info?.data?.update ?? []);
            setdeleteList(saverepeMsg?.status_info?.data?.delete ?? []);
            setskipUserList(saverepeMsg?.status_info?.data?.skip ?? []);
            setdefaultCalleridFlag(saverepeMsg?.status_info?.data?.is_default_caller_id !== undefined ? saverepeMsg.status_info.data.is_default_caller_id : 0)
            settotalSheetRecords(saverepeMsg?.status_info?.data?.total_records !== undefined ? saverepeMsg?.status_info?.data?.total_records : 0)
            setrecordNoAction(saverepeMsg?.status_info?.data?.no_action !== undefined ? saverepeMsg?.status_info?.data?.no_action : 0)
            setrecordsProcess(saverepeMsg?.status_info?.data?.rows_process !== undefined ? saverepeMsg?.status_info?.data?.rows_process : 0)
        } else {
            setinternalError(true);
            setErrorMessage(saverepeMsg.message);

        }

    }

    const handleCancelData = async () => {

        setIsloading(true);

        let saverep = await impExpCancel(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        let saverepeMsg = await saverep.json();

        setIsloading(false);
        console.log("handleSkipData of next:::" + JSON.stringify(saverepeMsg));

        if (saverepeMsg.status && saverepeMsg.status == "success") {
            props.onClose();
            window.location.href = "/userlanding";
        } else {
            setinternalError(true);
            setErrorMessage(saverepeMsg.message);

        }

    }


    const handleReupload = async () => {
        setIsloading(true);
        let saverep = await impExpCancel(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        let saverepeMsg = await saverep.json();
        setIsloading(false);
        if (saverepeMsg.status && saverepeMsg.status == "success") {
        setIsValidated(false);
        setIsImported(false);
        setIsInvalid(false);
        setselectedFiles(null);
        setuserDetails({});
        setErrorMessage("");
        setcreateList([]);
        setupdateList([]);
        setdeleteList([]);
        setskipUserList([]);
            setSkippedRecords({});
        } else {
            setinternalError(true);
            setErrorMessage(saverepeMsg.message);
        }
    };
    const toggleOpenisValidated = () => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
            setIsValidated(!isValidated);
        }, 3000);
    };


    return (
        <>

            {!isImported ? <>
                {/* <div>
                    <h5 className="mb-0 ">{t('downloadUsertxt')}</h5>
                    <MDBBtn className="mt-3"> <MDBIcon fas icon="download" className="me-2" />Download Template</MDBBtn>
                    <p className="mt-3">
                        <b> Note:</b> For SECURITY reasons, you must select whether you want to include Voicemail PINs in the export. You should use necessary security measures when exporting user Voicemail PINS</p>
                </div> */}
                {/* <div className="routing-border m-0 py-2"></div> */}
                <MDBContainer className="mopdalInputFeild">
                    <UploadFile
                        setselectedFiles={setselectedFiles}
                        selectedFiles={selectedFiles}
                        onShowInstructions={toggleOpen}
                        onExportUsers={handleExportUsers}
                        disableExport={disableExport}
                    />
                </MDBContainer>

                <MDBModalFooter>
                    <MDBBtn
                        type="button"
                        color="secondary"
                        onClick={(e) => {
                        setselectedFiles(null);
                        if (cancelContinueTriggered) {
                            setCancelContinueTriggered(false);
                            props.onClose();
                            window.location.href = "/userlanding";
                        } else {
                            props.onClose();
                        }
                        }}
                    >
                        Cancel
                    </MDBBtn>
                    <MDBBtn
                        type="button"
                        disabled={!selectedFiles || disableImportButton}
                        onClick={(e) => {
                            e.preventDefault();
                            handleUploadToValidate();
                        }}
                    >
                        Import
                    </MDBBtn>
                </MDBModalFooter>


            </> : <>

                {isValidated ? <>

                    <MDBContainer fluid>
                        <div className="mopdalInputFeild">
                            {savingRecordInfo?.Attention_Required && savingRecordInfo?.Attention_Required.length > 0 && (
                                <div className='rounded-2 w-100 my-2 text-left fs-6 p-3 bg-danger bg-opacity-10 border-danger border border-3' light>
                                    <strong>
                                        Attention Required
                                    </strong>
                                    <ol>
                                        {savingRecordInfo?.Attention_Required.map((item, index) => (
                                            <li>
                                                {item}

                                            </li>
                                        ))}
                                    </ol>
                                </div>
                            )}
                            {savingRecordInfo?.warnings_reasons && savingRecordInfo?.warnings_reasons.length > 0 && (
                                <div className='rounded-2 w-100 my-2 text-left fs-6 p-3 bg-danger bg-opacity-10 border-danger border border-3' light>
                                    <strong>
                                        Attention Required
                                    </strong>
                                    <ol>
                                        {savingRecordInfo?.warnings_reasons.map((item, index) => (
                                              <li key={index}>
                                                <b>
                                                    {`${item.fname}${item.lname ? " " + item.lname : ""}`}
                                                </b>
                                                : {item.reason}
                                            </li>
                                        ))}
                                    </ol>
                                </div>
                            )}

                            {
                                savingRecordInfo?.Provisioning_Records !== 0 && (
                                    <div className='my-2 text-left fs-6 p-3 bg-danger bg-opacity-10 border-danger border border-3' light>
                                        <strong>Provisioning Alert</strong><br></br>
                                        <strong>
                                            Please reboot the [re-]provisioned phone(s) to complete the configuration.
                                        </strong>
                                    </div>
                                )

                            }


                            <div className='my-2 text-left fs-6 p-3 bg-success bg-opacity-10 border-success border border-3' light>
                                <strong>
                                    Successfully Created/Edited/Deleted
                                </strong>
                                {savingRecordInfo?.Create_Records && savingRecordInfo?.Create_Records !== 0 && (

                                    <p>{savingRecordInfo?.Create_Records} User(s) created successfully.</p>
                                )}
                                {savingRecordInfo?.Update_Records && savingRecordInfo?.Update_Records !== 0 && (
                                    <p>{savingRecordInfo?.Update_Records} User(s) updated successfully.</p>
                                )}
                                {savingRecordInfo?.Delete_Records && savingRecordInfo?.Delete_Records !== 0 && (
                                    <p>{savingRecordInfo?.Delete_Records} User(s) removed successfully.</p>
                                )}

                            </div>
                        </div>
                        <MDBModalFooter>
                            <MDBBtn className='me-2' color='primary' onClick={(e) => { props.onClose(e); handleFinishRequest(); }}>Finish</MDBBtn>
                        </MDBModalFooter>
                        {/* <div className='my-2'>
                            <div className='my-2 text-left fs-6 p-3 bg-danger bg-opacity-10 border-danger border border-3' light>
                                Error(s): The following invalid data has been found in the SPread Sheet which cannot be used to create/edit the user(s) - 1 Record(s)
                            </div>
                        </div> */}


                        {/* <div className='my-3 text-center'>
                            <p>Total Uploaded Rows: <strong>2</strong></p>
                            <p>Total Rows on which No Action Taken : <strong>2</strong></p>
                            <p>Total Rows to Process: <strong>2</strong></p>
                            <p className='red'>If caller ID field is EMPTY, then ACCOUNT Default Caller ID will be assigned as users caller ID by default.</p>
                        </div> */}
                        {/* <MDBModalFooter className="mt-4">
                            <MDBBtn className='me-2' color='secondary' >Finish</MDBBtn>

                        </MDBModalFooter> */}
                    </MDBContainer>
                </> : <>
                    {isInValid ? (() => {
                        const hasErrorRecords = (userDetails?.error_rows?.length ?? 0) > 0;
                        const hasSkippedRecords = Object.keys(skippedRecords).length > 0;
                        const skippedTableData = hasSkippedRecords ? {
                            columns: [
                                { label: "Row", field: "rowid", sort: false },
                                { label: "First Name", field: "firstName", sort: false },
                                { label: "Last Name", field: "lastName", sort: false },
                                { label: "Email Address", field: "email", sort: false },
                                { label: "Extension", field: "extension", sort: false },
                                { label: "Service Plan", field: "servicePlan", sort: false },
                                { label: "International Calling", field: "classtype", sort: false },
                                { label: "Caller ID", field: "callerId", sort: false },
                                { label: "DID", field: "did", sort: false },
                                { label: "Location", field: "location", sort: false },
                                { label: "Record All Calls", field: "recordallcalls", sort: false },
                                { label: "Billing Group", field: "billinggroup", sort: false },
                                { label: "IP1 Mac ID", field: "ip1macaddress", sort: false },
                                { label: "IP1 911 Location", field: "ip1nineolocation", sort: false },
                                { label: "IP1 Phone Make", field: "ip1model", sort: false },
                                { label: "IP1 MLA", field: "ip1mla", sort: false },
                                { label: "IP1 No. of MLA Lines", field: "ip1no_mla", sort: false },
                                { label: "IP2 Mac ID", field: "ip2macaddress", sort: false },
                                { label: "IP2 911 Location", field: "ip2nineolocation", sort: false },
                                { label: "IP2 Phone Make", field: "ip2model", sort: false },
                                { label: "IP2 MLA", field: "ip2mla", sort: false },
                                { label: "IP2 No. of MLA Lines", field: "ip2no_mla", sort: false },
                            ],
                            rows: Object.values(skippedRecords).map(item => {
                                const r = item.row_info ?? {};
                                return {
                                    rowid: r.rowid ?? "",
                                    firstName: r.fname ?? "",
                                    lastName: r.lname ?? "",
                                    email: r.emailid ?? "",
                                    extension: r.extension ?? "",
                                    servicePlan: r.serviceplan ?? "",
                                    classtype: r.classtype ?? "",
                                    callerId: r.caller_id ?? "",
                                    did: r.added_dids ?? "",
                                    location: r.location ?? "",
                                    recordallcalls: r.recordallcalls ?? "",
                                    billinggroup: r.billinggroup ?? "",
                                    ip1macaddress: r.ip1macaddress ?? "",
                                    ip1nineolocation: r.ip1nineolocation ?? "",
                                    ip1model: r.ip1model ?? "",
                                    ip1mla: r.ip1mla ?? "",
                                    ip1no_mla: r.ip1no_mla ?? "",
                                    ip2macaddress: r.ip2macaddress ?? "",
                                    ip2nineolocation: r.ip2nineolocation ?? "",
                                    ip2model: r.ip2model ?? "",
                                    ip2mla: r.ip2mla ?? "",
                                    ip2no_mla: r.ip2no_mla ?? "",
                                };
                            })
                        } : null;

                        return <>
                        <div className="mopdalInputFeild">
                                {hasErrorRecords && (
                            <ErrorValidataion
                                register={register}
                                control={control}
                                setValue={setValue}
                                reset={reset}
                                watch={watch}
                                userDetail={userDetails}
                                setIsloading={setIsloading}
                                isloading={isloading}
                            />
                                )}
                                {hasSkippedRecords && (
                                    <>
                                        <div className="my-2 text-left fs-6 p-3 bg-danger bg-opacity-10 border-danger border border-3">
                                            <strong>The following records were skipped because of an Invalid System Generated ID.</strong>
                                        </div>
                                        <div className="importExportDatatable">
                                            <div className="actionbar"></div>
                                            <MDBDatatable
                                                search
                                                fixedHeader
                                                maxHeight="600px"
                                                minHeight="240px"
                                                hover
                                                className="actioncolumnbig"
                                                pagination={true}
                                                data={skippedTableData}
                                            />
                                        </div>
                                    </>
                                )}
                        </div>

                        <MDBModalFooter>
                            <MDBBtn className='me-2' color='secondary' onClick={(e) => { props.onClose(e); handleCancelData(); }}>Cancel</MDBBtn>
                                {hasErrorRecords && (
                            <MDBBtn className='me-2' color='primary' onClick={(e) => { e.preventDefault(); handleSubmit(handleInvalidData)(); }}>Validate</MDBBtn>
                                )}
                            <MDBBtn className='me-2' color='primary' onClick={(e) => { e.preventDefault(); handleSkipData(); }}>Skip</MDBBtn>
                        </MDBModalFooter>
                        </>;
                    })() :
                        (
                            <>
                                <div className="mopdalInputFeild">

                                    <SuccessValidationPage
                                        createList={createList}
                                        updateList={updateList}
                                        deleteList={deleteList}
                                        skipUserList={skipUserList}
                                        totalSheetRecords={totalSheetRecords}
                                        recordNoAction={recordNoAction}
                                        recordsProcess={recordsProcess}
                                        defaultCalleridFlag={defaultCalleridFlag}
                                    />
                                </div>
                                <MDBModalFooter>
                                    <MDBBtn className='me-2' color='secondary' onClick={(e) => { props.onClose(e); handleCancelData(); }}>Cancel</MDBBtn>
                                    {(recordsProcess - skipUserList?.length ?? 0) != 0 && <MDBBtn className='me-2' color='primary' disabled={((createList.length + updateList.length + deleteList.length) === 0)} onClick={(e) => { e.preventDefault(); handleSaveData(); }}>Save</MDBBtn>}
                                    {(recordsProcess - skipUserList?.length ?? 0) == 0 && <MDBBtn className='me-2' color='primary' onClick={(e) => { e.preventDefault(); handleReupload() }}>Re-Upload</MDBBtn>}
                                </MDBModalFooter>
                            </>
                        )}

                </>}

            </>}
            {isLoading && <>
                <div className="loadingclass-popup">
                    {/* <div className="bg-light p-4 rounded-4 shadow-4 w-auto d-flex align-items-center">
                        <div>
                            <div className="cursor-pointer progress-bar-container border-0" style={{ width: "400px" }}>
                                <div>
                                    <p className={`${statusPercentage === "100" ? "text-success" : "text-primary"} fw-bold mb-0 lh-normal`}>
                                        {statusPercentage === "100" ? "Completed" : "Importing Users"}
                                        {statusPercentage === "100" && <MDBIcon fas icon="check-circle" className="ms-2" color="success" />}
                                    </p>
                                </div>
                                <div className="d-flex align-items-center mt-1">
                                    <div className="w-100">
                                        <MDBProgress>
                                            <MDBProgressBar bgColor={statusPercentage === "100" ? "success" : ""} striped={statusPercentage === "100" ? false : true} animated width={statusPercentage} valuemin={0} valuemax={100} />
                                        </MDBProgress>
                                    </div>
                                    <span className="text-muted ms-2 lh-normal">{statusPercentage}%</span>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    <div className="bg-light p-4 rounded-4 shadow-4 w-auto d-flex align-items-center">
                        {/* <MDBSpinner size="lg" tag="span" color="dark" className="me-4" /> */}
                        <div>
                            {finalSaveStatus ? (<>
                                <p>
                                    The system is currently processing user data (adding/editing/deleting). This may take a few minutes to complete.
                                </p>

                                <p>
                                    Note:You may click <b>OK</b> to continue using the application while the operation completes in the background.
                                </p>
                            </>) : (<>
                                Please wait while processing (adding/editing/deleting) the user data. It may take few minutes to complete the process.
                                <p>
                                    Note: Please do not close the browser or click back or refresh the browser.
                                </p>
                            </>)}

                            {/* {(responseStatus === 1 || responseStatus === 4 || responseStatus === 6) && (<> */}
                                {finalSaveStatus && responseStatus !== 1 ? (<>
                                    <div >
                                        <div className="cursor-pointer progress-bar-container border-0 w-100 px-0 mt-2">
                                            <div>
                                                <p className={`${statusPercentage === "100" ? "text-success" : "text-primary"} fw-bold mb-0 lh-normal`}>
                                                    {/* {statusPercentage === "100" ? "Completed" : "Importing Users"} */}
                                                    {statusPercentage === "100" && <MDBIcon fas icon="check-circle" className="ms-2" color="success" />}
                                                </p>
                                            </div>
                                            <div className="d-flex align-items-center mt-1 custom-progress-bar">
                                                <div className="w-100">
                                                    <MDBProgress>
                                                        <MDBProgressBar bgColor={statusPercentage === "100" ? "success" : ""} striped={statusPercentage === "100" ? false : true} animated width={statusPercentage} valuemin={0} valuemax={100} />
                                                    </MDBProgress>
                                                </div>
                                                <span className="text-muted ms-2 lh-normal">{statusPercentage}%</span>
                                            </div>
                                        </div>
                                    </div>
                                </>) : (
                                    <>
                                        <p>
                                            {responseStatus === 1 ? "validation processing" : responseStatus === 4 ? "processing users" : responseStatus === 6 ? "processing Seats Deletion" : "processing Seats"} {statusPercentage === "0" ? finalSaveStatus ? "0/0" : "0%" : statusPercentage}
                                        </p>
                                    </>
                                )}
                            {/* </>)} */}
                            <div className="d-flex justify-content-center mt-2">
                                {finalSaveStatus && (
                                    <MDBBtn onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setforceStop(false);
                                        // sessionStorage.setItem("user_imported", true);
                                        window.location.href = "/userlanding";
                                    }}>
                                        OK
                                    </MDBBtn>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
            }

            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}


            {centredModal && (
                <div className="inside-modal">
                    <PopupLoader
                        title={"Export User Template"}
                        className="modal-lg"
                        content={
                            <>
                                <ul>
                                    <li><strong>Required Fields:</strong> First Name, Email, User ID, and Service Plan are mandatory. Extension, Password, and PIN are auto-generated if empty. IP Phone details are optional unless configuring a device.</li>
                                    <li><strong>First & Last Name:</strong> Letters only. First Name must not exceed 30 characters; Last Name must not exceed 20 characters.</li>
                                    <li><strong>Email ID:</strong> Alphanumeric and globally approved special characters (<code>_</code>, <code>-</code>, <code>.</code>) allowed (max 50 chars). E.g., <code>sally24_doe@mycompany.com</code></li>
                                    <li><strong>User ID:</strong> Must be unique, containing lowercase alphabets only, and not exceed 50 characters. E.g., <code>sallyjohn</code></li>
                                    <li><strong>Voicemail PIN:</strong> Numeric characters only; length must be exactly 5 or 6 digits.</li>
                                    <li><strong>Extension:</strong> Must be unique and exactly 4 digits. Note that all 999X extensions are reserved.</li>
                                    <li><strong>Service Plan:</strong> Choose standard plan from spreadsheet dropdown (e.g., Business Voice, WS-UCC). Do not enter custom names.</li>
                                    <li><strong>DID (Direct Inward Dialing):</strong> Numeric characters only; length must be 10 or 11 digits and purchased beforehand.</li>
                                    <li><strong>Call Permissions:</strong> Select "Yes" to allow International/Local calls or "No" to allow Local calls only.</li>
                                </ul>
                            </>
                        }
                        onShow={setCentredModal}
                        onClose={toggleOpen}
                    />
                </div>
            )}

            {/* NEW: Continue existing import confirmation popup */}
            {showContinuePopup && (
                <PopupLoader
                    title={"Import Operation"}
                    content={
                        <>
                            <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                                <MDBIcon
                                    fas
                                    icon="question-circle"
                                    className="me-3 fs-5 mt-1"
                                    color="warning"
                                />
                                <div>
                                    User Import is in progress. Click <strong>Proceed</strong> to continue the current process, or click <strong>Cancel</strong> to discard it and start a new one. 
                                </div>
                            </div>
                            <MDBModalFooter>
                                <MDBBtn
                                    color="secondary"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleCancelContinue();
                                    }}
                                >
                                    Cancel
                                </MDBBtn>
                                <MDBBtn
                                    color="primary"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleContinueImport();
                                    }}
                                >
                                    Proceed
                                </MDBBtn>
                            </MDBModalFooter>
                        </>
                    }
                    onShow={setShowContinuePopup}
                    onClose={(e) => {
                        e.preventDefault();
                        setShowContinuePopup(false);
                    }}
                />
            )}

            {
                internalError && (<MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setinternalError(false)}
                >{errorMessage}</MDBAlert>)
            }

            {/* <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => { e.preventDefault(); handleUploadToValidate() }}>
                    {t("import")}</button>
            </div> */}
        </>
    )
};
export default ImportUser